import { render, staticRenderFns } from "./AddressBookAddressTable.vue?vue&type=template&id=411851dc&"
import script from "./AddressBookAddressTable.vue?vue&type=script&lang=ts&"
export * from "./AddressBookAddressTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports